"use client";

import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { RefreshCw, Trash2, Sparkles } from "lucide-react";
import { getViewModeChrome } from "../view-mode-chrome";

const stages = [
  {
    id: 1,
    text: "Liquidating positions...",
    duration: 500,
    icon: RefreshCw,
  },
  {
    id: 2,
    text: "Clearing ledger...",
    duration: 900,
    icon: Trash2,
  },
  {
    id: 3,
    text: "Reinitializing environment...",
    duration: 700,
    icon: Sparkles,
  },
];

export function RestartNotebookLoading({ viewMode }: { viewMode?: string } = {}) {
  const chrome = getViewModeChrome(viewMode);
  const [currentStage, setCurrentStage] = useState(0);

  useEffect(() => {
    const timers: NodeJS.Timeout[] = [];
    let totalDelay = 0;

    stages.forEach((stage, index) => {
      const timer = setTimeout(() => {
        setCurrentStage(index);
      }, totalDelay);
      totalDelay += stage.duration;
      timers.push(timer);
    });

    return () => timers.forEach(clearTimeout);
  }, []);

  const current = stages[currentStage] || stages[0];
  const Icon = current.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="w-full"
    >
      <div className={`rounded-md border ${chrome.card} overflow-hidden`}>
        <div className="px-3 py-2 flex items-center gap-2.5">
          <div
            className="w-7 h-7 rounded bg-muted/50 flex items-center justify-center"
          >
            <Icon className={`w-3.5 h-3.5 ${chrome.iconMuted} shrink-0`} strokeWidth={2} />
          </div>

          <AnimatePresence mode="wait">
            <motion.span
              key={current.id}
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 8 }}
              transition={{ duration: 0.2 }}
              className={`text-[13px] font-semibold ${chrome.text} truncate`}
            >
              {current.text}
            </motion.span>
          </AnimatePresence>
        </div>
      </div>
    </motion.div>
  );
}
